import React, { PropsWithChildren } from 'react';

import styled from '@emotion/styled';

const StakingAlertContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing('0750')};
  background: ${({ theme }) => theme.color.redContainer};
  border-radius: ${({ theme }) => theme.shape.corner['0500']};
  color: ${({ theme }) => theme.color.onRedContainer};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['0875']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
`;

export const StakingAlert = ({ children }: PropsWithChildren) => {
  return <StakingAlertContainer>{children}</StakingAlertContainer>;
};
